/**
 * Точка входа webpack: landing.monitoring
 */
import './monitoring.css';
import '../../common.js';
import '../../modules/demo/demo.js';
import '../../modules/partners/partners.js';
import '../../modules/tariffs/tariffs.js';
import { initLandingVideo } from '../../modules/video/video.js';
import { initFaq } from '../../modules/faq/faq.js';
import { initReviews } from '../../modules/reviews/reviews.js';
import { initSlidesWhite } from '../../modules/slides_white/slides_white.js';

/**
 * Очищаем URL до посадочной, если пришли с deep-link на отчёт.
 */
function normalizeLandingUrl() {
    if (typeof window.locale !== 'string' || !window.locale) {
        return;
    }
    const target = '/' + window.locale + '/monitoring';
    if (window.location.pathname !== target) {
        history.pushState(null, '', target);
    }
}

function init() {
    normalizeLandingUrl();
    initSlidesWhite();
    initLandingVideo();
    initFaq();
    initReviews();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
